import { storage } from "../firebase";
import { makeid } from "../utils/pageactions";
import styles from "./styles.module.css";
import Files from "../pages/canvas/files";
import { useState, useEffect } from "react";
import Dynamic from "./dynamic";

export default function Image({ value, onChange, params, sources }) {
  const [open, setOpen] = useState(false);
  const [_value, setValue] = useState("");
  const [dynamic, setDyanmic] = useState(false);

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
      setValue("");
    }
  }, [value]);
  useEffect(() => {
    if (Array.isArray(value)) {
      setDyanmic(true);
    } else {
      setDyanmic(false);
    }
  }, [value]);

  const onSelect = (f) => {
    onChange(f.url);
    setOpen(false);
  };

  const handleToggle = () => {
    if (dynamic) {
      onChange("");
    } else {
      onChange(["", {}, ""]);
    }
  };

  const handleClear = () => {
    setValue("");
    onChange("");
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          backgroundColor: "#e2e2f4",
          padding: 4,
          borderRadius: 8,
          fontFamily: "var(--font)",
          marginBottom: 20,
        }}
      >
        <div
          style={{
            flexGrow: 1,
            textAlign: "center",
            backgroundColor: dynamic ? "" : "white",
            borderRadius: 8,
            padding: 4,
            flexBasis: 0,
            cursor: "pointer",
          }}
          onClick={handleToggle}
        >
          Static
        </div>
        <div
          style={{
            flexGrow: 1,
            flexBasis: 0,
            textAlign: "center",
            borderRadius: 8,
            padding: 4,
            backgroundColor: dynamic ? "white" : "",
            cursor: "pointer",
          }}
          onClick={handleToggle}
        >
          Dynamic
        </div>
      </div>
      {!dynamic ? (
        <div>
          {_value.length > 0 && (
            <div
              style={{
                width: 80,
                height: 60,
                backgroundImage: `url(${_value})`,
                backgroundSize: "cover",
                borderRadius: 5,
                marginBottom: 12,
                border: "1px solid var(--main-border-color)",
              }}
            />
          )}

          <button onClick={() => setOpen(true)} className={styles.imageSelect}>
            {_value.length > 0 ? "Change Image" : "Select Image"}
          </button>
          {_value.length > 0 && (
            <div onClick={handleClear} className={styles.clear}>
              Clear Image
            </div>
          )}
        </div>
      ) : (
        <Dynamic
          value={_value}
          onChange={onChange}
          params={{ type: "Text", list: false }}
          sources={[...sources]}
        />
      )}

      <Files open={open} onSelect={onSelect} onClose={() => setOpen(false)} />
    </>
  );
}
